/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Injectable } from "@angular/core";
var ExpandableRowsCount = (function () {
    function ExpandableRowsCount() {
        this.expandableCount = 0;
    }
    ExpandableRowsCount.prototype.register = function () {
        this.expandableCount++;
    };
    ExpandableRowsCount.prototype.unregister = function () {
        this.expandableCount--;
    };
    Object.defineProperty(ExpandableRowsCount.prototype, "hasExpandableRow", {
        /**
         * false means no rows with action
         */
        get: function () {
            return this.expandableCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    return ExpandableRowsCount;
}());
export { ExpandableRowsCount };
ExpandableRowsCount.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ExpandableRowsCount.ctorParameters = function () { return []; };
//# sourceMappingURL=global-expandable-rows.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/providers/global-expandable-rows.js
// module id = 51
// module chunks = 4